<script>
  import Section from "../../../components/layout/Section.svelte";
  import SectionTitle from "../../../components/layout/SectionTitle.svelte";
  import { translate } from "../../../i18n/i18next.js";
  import ProjectUsersList2 from "../../../components/project/ProjectUsersList2.svelte";
  import Stack from "../../../components/layout/Stack.svelte";
  import PrimaryButton from "../../../components/button/generic/PrimaryButton.svelte";
  import { getAutoMpsProjectContext } from "../../AutoMpsProjectContext.js";
  import InvitationDialog2 from "../../../components/project/invitationDialog/InvitationDialog2.svelte";

  const ctx = getAutoMpsProjectContext()

  let isInvitationDialogOpen = false
</script>

<Section>
  <SectionTitle title={translate("frontend:pages:projects.project.admin.sections.users.title")} />
  <Stack direction="vertical" style="width: 100%">
    <ProjectUsersList2 />
    <Stack direction="horizontal" gap=".5rem">
      <PrimaryButton onClick={() => isInvitationDialogOpen = true}>
        {translate("frontend:pages:projects.project.admin.sections.users.inviteUser")}
      </PrimaryButton>
    </Stack>
  </Stack>
  {#if isInvitationDialogOpen}
    <InvitationDialog2
      projectId={$ctx.projectId}
      onClose={() => isInvitationDialogOpen = false}
    />
  {/if}
</Section>
